import styled from 'styled-components/native';

import { isWebPlatform } from '../../../boot/utils';
import { neutralDark, neutralLight, warrior } from '../../../constants/color';
import LoadingView from '../../../elements/LoadingView';
import Touchable from '../../../elements/Touchable';

export default {
  RetryApplePayBtn: styled(Touchable)`
    align-items: center;
    border-color: ${({ disabled }) => (disabled ? neutralLight : neutralDark)};
    border-radius: 3px;
    border-width: 1px;
    display: ${({ disabled }) =>
      disabled && isWebPlatform ? 'block' : 'flex'};
    margin-top: 10px;
    padding-bottom: 12px;
    padding-top: 12px;
    text-align: center;
    line-height: 12px;
  `,
  RetryApplePayText: styled.Text`
    color: ${warrior};
  `,
  RetryApplePayLoading: styled(LoadingView)`
    color: ${neutralLight};
  `,
};
